import type { ITheme } from '@ben/orion/utils/theme';
import type { ColumnPinningPosition } from '@tanstack/react-table';
import styled, { css } from 'styled-components';

export const TableWrapper = styled.div<{ enableHorizontalScroll?: boolean }>`
  ${({ theme, enableHorizontalScroll }) => css`
    width: 100%;
    border: 1px solid ${theme.palette.neutral[60]};
    border-radius: ${theme.borderRadius.sm};
    background-color: ${theme.palette.neutral['00']};
    overflow-x: ${enableHorizontalScroll ? 'auto' : undefined};
  `}
`;

export const StyledTable = styled.table`
  width: 100%;
  border-spacing: 0;
`;

export const StyledTableRow = styled.tr`
  ${({ theme, $hasOnClick }: { theme: ITheme; $hasOnClick: boolean }) => css`
    ${$hasOnClick &&
    `
      &:hover {
        cursor: pointer;
        background-color: ${theme.palette.neutral[40]};
      }
    `}
  `}
`;

export const StyledTableData = styled.td`
  ${({
    theme,
    $textAlign,
    $maxWidth,
    $hug,
    $isPinned,
  }: {
    theme: ITheme;
    $textAlign?: string;
    $maxWidth?: number;
    $hug?: boolean;
    $isPinned?: ColumnPinningPosition;
  }) => css`
    ${theme.typography.bodyMd1};
    color: ${theme.palette.neutral[100]};
    padding: ${theme.spacing(1, 2)};
    border-bottom: 1px solid ${theme.palette.neutral[50]};
    text-align: ${$textAlign};
    max-width: ${$maxWidth};
    height: ${theme.spacing(7.5)}; // Works like min-height on table cells
    word-break: ${$hug ? undefined : 'break-word'};

    // Pinned column styles
    position: ${$isPinned ? 'sticky' : undefined};
    left: ${$isPinned === 'left' ? '0' : undefined};
    right: ${$isPinned === 'right' ? '0' : undefined};
    background-color: ${$isPinned ? theme.palette.white(0.9) : undefined};

    // Darker sub-pixel border for retina screens
    @media (min-resolution: 2x) {
      border-bottom: 0.5px solid ${theme.palette.neutral[60]};
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: ${theme.spacing(1.5)};
      height: ${theme.spacing(5)}; // Works like min-height on table cells
    }
  `}
`;
